<template>
  <div id="section-to-print" v-if="storePerbandingan">
    <div
      class="row add-page-break-after"
      v-for="(perbandingan, indexPerbandingan) in storePerbandingan"
      :key="indexPerbandingan"
    >
      <div class="col-12">
        <div class="p-3 mb-3">
          <div class="row">
            <div class="col-12">
              <h5 class="header-title">PERBANDINGAN GAJI/UPAH</h5>
              <h5 class="header-title">
                {{ toUpper(perbandingan.titleBulan) }}
              </h5>

              <table class="table">
                <thead>
                  <tr class="center-top-text">
                    <th rowspan="3"></th>
                    <th rowspan="3" style="min-width: 120px">URAIAN</th>
                    <th colspan="2">BULAN</th>
                    <th colspan="2">SELISIH</th>
                  </tr>

                  <tr class="center-top-text">
                    <th style="min-width: 80px">
                      {{ toUpper(perbandingan.bulan1OnlyMonth) }}
                    </th>
                    <th style="min-width: 80px">
                      {{ toUpper(perbandingan.bulan2OnlyMonth) }}
                    </th>
                    <th style="min-width: 80px">NAIK / TURUN</th>
                    <th style="min-width: 80px">KETERANGAN</th>
                  </tr>

                  <tr class="center-top-text">
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>
                    <th>(Rp.)</th>

                    <th></th>
                  </tr>
                  <tr class="center-top-text">
                    <th>1</th>
                    <th>2</th>
                    <th>3</th>
                    <th>4</th>
                    <th>5</th>
                    <th>6</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(uraian, indexUraian) in perbandingan.dataTetap"
                    :key="indexUraian"
                  >
                    <td style="border: 1px solid #000">
                      {{ indexUraian + 1 }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ uraian.komponen }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(uraian.bulan1) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(uraian.bulan2) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(uraian.bulan2 - uraian.bulan1) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ uraian.keterangan }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" style="border: 1px solid #000">JUMLAH</td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(perbandingan.total1) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{ formatNumber(perbandingan.total2) }}
                    </td>
                    <td style="border: 1px solid #000">
                      {{
                        formatNumber(perbandingan.total2 - perbandingan.total1)
                      }}
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colspan="2" style="border: 1px solid #000">
                      Gaji yang dibayar
                    </td>
                    <td colspan="4" style="border: 1px solid #000">
                      {{ formatNumber(perbandingan.total2) }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="row arial12">
                <div class="col-12">
                  <p>
                    Terbilang : -----
                    {{ formatNumberTerbilang(perbandingan.total2) }}
                    Rupiah -----
                  </p>
                </div>
                <div class="row" style="text-align: center">
                  <div class="col-4">
                    <br />
                    <br />
                    Mengetahui: <br />
                    <br />

                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.dirum"
                    >
                      {{ pejabat.dirum.nama }}
                    </div>

                    Direktur Umum
                  </div>
                  <div class="col-4">
                    <br />
                    <br />
                    Diperiksa:<br />
                    <br />

                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.pejabatMengetahui"
                    >
                      {{ pejabat.pejabatMengetahui.nama }}
                    </div>
                    <div v-if="pejabat.pejabatMengetahui">
                      {{ pejabat.pejabatMengetahui.jabatan }}
                    </div>
                  </div>
                  <div class="col-4">
                    Singaraja,
                    {{ convertTglIndonesia(perbandingan.tglApproved) }}
                    <br />

                    Dibuat Oleh:<br />
                    <br />

                    <div
                      style="text-decoration: underline; padding-top: 35px"
                      v-if="pejabat.pejabatMembuat"
                    >
                      {{ pejabat.pejabatMembuat.nama }}
                    </div>
                    <div v-if="pejabat.pejabatMembuat">
                      {{ pejabat.pejabatMembuat.jabatan }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="add-page-break-before">
                <br />
                <h5
                  style="
                    font-weight: bold;
                    font-family: Arial, sans-serif;
                    font-size: 12px;
                  "
                >
                  REKAP GAJI/UPAH {{ toUpper(perbandingan.bulan2) }}
                </h5>
                <table class="table-rekap" v-if="storeRekap">
                  <thead>
                    <tr class="center-top-text">
                      <th rowspan="2" style="min-width: 120px">KETERANGAN</th>
                      <th rowspan="2">GAPOK</th>
                      <th colspan="7">TUNJANGAN</th>
                      <th rowspan="2">POT.<br />PERSONALIA</th>
                      <th rowspan="2">JUMLAH<br />BRUTO</th>
                      <th rowspan="2">T. PPH</th>
                      <th rowspan="2">JUMLAH</th>
                      <th rowspan="2">POT.<br />KESEHATAN</th>
                      <th rowspan="2">BPJS TK<br />3 PROGRAM</th>
                      <th rowspan="2">BPJS TK<br />4 PROGRAM</th>
                      <th rowspan="2">PENSIUN<br />JIWASRAYA</th>
                      <th rowspan="2">POT<br />PPH</th>
                      <th rowspan="2">YANG<br />DITERIMA</th>
                    </tr>

                    <tr class="center-top-text">
                      <th>PERUSAHAAN</th>
                      <th>JABATAN</th>
                      <th>KEMAHALAN</th>
                      <th>AIR</th>
                      <th>TRANSPORT</th>
                      <th>PANGAN</th>
                      <th>KESEHATAN</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(rekap, indexRekap) in storeRekap[
                        indexPerbandingan
                      ].tetap"
                      :key="indexRekap"
                    >
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ rekap.key }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.gaji_pokok) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.tun_perusahaan) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.tun_jabatan) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.tun_kemahalan) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.tun_air) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.tun_transport) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.tun_pangan) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.tun_kesehatan) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.pot_5_persen) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.jml_bruto) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.tun_pph) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.jumlah) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.pot_kesehatan) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.pot_bpjs_tk_tiga_program) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{
                          formatNumber(rekap.value.pot_bpjs_tk_empat_program)
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.pot_pensiun) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.pot_pph) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.total_diterima) }}
                      </td>
                    </tr>
                    <tr>
                      <td><br /></td>
                    </tr>
                    <tr>
                      <td style="border: 1px solid #000">
                        KETERANGAN<br />(Pekerja Kontrak)
                      </td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000">
                        TUNJ.<br />KESEHATAN
                      </td>
                      <td style="border: 1px solid #000">
                        POT<br />PERSONALIA
                      </td>
                      <td style="border: 1px solid #000">JUMLAH<br />BRUTO</td>
                      <td style="border: 1px solid #000" colspan="2">
                        GAJI/UPAH YG DIBAYAR
                      </td>
                      <td style="border: 1px solid #000">POT<br />KESEHATAN</td>
                      <td style="border: 1px solid #000">BPJS<br />TK</td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000">
                        HONOR<br />DITERIMA
                      </td>
                    </tr>
                    <tr
                      v-for="(rekap, indexRekap) in storeRekap[
                        indexPerbandingan
                      ].honor"
                      :key="indexRekap"
                    >
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ rekap.key }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{
                          formatNumber(
                            rekap.value.jml_bruto - rekap.value.tun_kesehatan,
                          )
                        }}
                      </td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.tun_kesehatan) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.pot_5_persen) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.jml_bruto) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{
                          formatNumber(
                            rekap.value.jml_bruto -
                              rekap.value.tun_kesehatan -
                              rekap.value.pot_5_persen,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.jml_bruto) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.pot_kesehatan) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.pot_bpjs_tk_dua_persen) }}
                      </td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td style="border: 1px solid #000"></td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.total_diterima) }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': true }"
                        colspan="8"
                      >
                        JUMLAH KESELURUHAN
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': true }"
                      >
                        {{
                          formatNumber(
                            storeRekap[indexPerbandingan].all[0].value
                              .tun_kesehatan,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': true }"
                      >
                        {{
                          formatNumber(
                            storeRekap[indexPerbandingan].all[0].value
                              .pot_5_persen,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': true }"
                      >
                        {{
                          formatNumber(
                            storeRekap[indexPerbandingan].all[0].value
                              .jml_bruto,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': true }"
                      >
                        {{
                          formatNumber(
                            storeRekap[indexPerbandingan].all[0].value.tun_pph,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': true }"
                      >
                        {{
                          formatNumber(
                            storeRekap[indexPerbandingan].all[0].value.jumlah,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': true }"
                      >
                        {{
                          formatNumber(
                            storeRekap[indexPerbandingan].all[0].value
                              .pot_kesehatan,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': true }"
                      >
                        {{
                          formatNumber(
                            storeRekap[indexPerbandingan].all[0].value
                              .pot_bpjs_tk,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': true }"
                      >
                        {{
                          formatNumber(
                            storeRekap[indexPerbandingan].all[0].value
                              .pot_bpjs_tk_empat_program,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': true }"
                      >
                        {{
                          formatNumber(
                            storeRekap[indexPerbandingan].all[0].value
                              .pot_pensiun,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': true }"
                      >
                        {{
                          formatNumber(
                            storeRekap[indexPerbandingan].all[0].value.pot_pph,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': true }"
                      >
                        {{
                          formatNumber(
                            storeRekap[indexPerbandingan].all[0].value
                              .total_diterima,
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <div class="row arial12">
                  <div class="header-title">
                    <p>
                      TOTAL BAYAR:
                      {{
                        formatNumber(
                          storeRekap[indexPerbandingan].all[0].value.jumlah,
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- end of add-page-break-before -->

              <div class="add-page-break-before">
                <br />
                <h5
                  style="
                    font-weight: bold;
                    font-family: Arial, sans-serif;
                    font-size: 12px;
                  "
                >
                  REKAP GAJI/UPAH PEKERJA KONTRAK
                  {{ toUpper(perbandingan.bulan2) }}
                </h5>
                <table class="table-rekap" v-if="storeRekap">
                  <thead>
                    <tr class="center-top-text">
                      <th rowspan="3" style="min-width: 120px"></th>
                      <th rowspan="3">UPAH<br />(UMK)</th>
                      <th rowspan="3">
                        TAMBAHAN<br />UPAH BERDASARKAN<br />MASA KERJA
                      </th>
                      <th rowspan="3">TUNJANGAN<br />KESEHATAN</th>
                      <th rowspan="3">POT.<br />PERS.</th>
                      <th rowspan="3">JUMLAH</th>
                      <th rowspan="3">TUNJANGAN<br />BPJS T.KERJA</th>
                      <th rowspan="3">JUMLAH<br />BRUTO</th>
                      <th rowspan="3">POT.<br />KESEHATAN</th>
                      <th rowspan="3">POT. BPJS<br />T.KERJA</th>
                      <th rowspan="3">YANG<br />DITERIMA</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <tr
                      v-for="(rekap, indexRekap) in storeRekap[
                        indexPerbandingan
                      ].kontrak"
                      :key="rekap.id"
                    > -->
                    <tr
                      v-for="(rekap, indexRekap) in filteredKontrak(
                        indexPerbandingan,
                      )"
                      :key="indexRekap"
                    >
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ rekap.key }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.honor_umk_jml) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.kenaikan_masa_kerja) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.tun_kesehatan) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.pot_5_persen) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.jumlah) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{
                          formatNumber(
                            rekap.value.tun_bpjs_tk_satu_sembilanbelas_persen,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.jml_bruto) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.pot_kesehatan) }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{
                          formatNumber(
                            rekap.value.pot_bpjs_tk_satu_sembilanbelas_persen,
                          )
                        }}
                      </td>
                      <td
                        style="border: 1px solid #000"
                        :class="{ 'bold-text': rekap.key === 'JUMLAH' }"
                      >
                        {{ formatNumber(rekap.value.total_diterima) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- end of add-page-break-before  -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /section-to-print -->
</template>

<style scoped lang="scss">
.header-title {
  font-weight: bold;
  text-align: center;
  font-family: Arial, sans-serif; /* Set font to Arial */
  font-size: 15px;
}

.add-page-break-before {
  page-break-before: always;
}
.add-page-break-after {
  page-break-after: always;
}
.center-top-text {
  vertical-align: top; /* Align text to the top */
  text-align: center; /* Center text horizontally */
}

.table {
  width: 100%;
  border: 1px solid #000; /* Adjust the border thickness as needed */
  border: collapse;
  font-family: Arial, sans-serif; /* Set font to Arial */
  font-size: 10px; /* Set font size to 10 */
}

.table-rekap {
  width: 100%;
  border: 1px solid #000; /* Adjust the border thickness as needed */
  border: collapse;
  font-family: Arial, sans-serif; /* Set font to Arial */
  font-size: 10px; /* Set font size to 10 */
}

.table th,
.table td {
  vertical-align: top; /* Align text to the top */
  min-width: 5px; /* Ensure a minimum width for readability */
  max-width: 500px; /* Ensure a maximum width for readability */
  border: 1px solid #000; /* Adjust the border thickness as needed */
  padding: 1px; /* Adjust this value as needed */
  vertical-align: middle; /* Center align the text vertically */
}

.table-rekap th,
.table-rekap td {
  vertical-align: top; /* Align text to the top */
  min-width: 5px; /* Ensure a minimum width for readability */
  max-width: 500px; /* Ensure a maximum width for readability */
  border: 1px solid #000; /* Adjust the border thickness as needed */
  padding: 5px; /* Adjust this value as needed */
  vertical-align: middle; /* Center align the text vertically */
}

.bold-text {
  font-weight: bold;
}

@media print {
  // table {
  //   page-break-inside: avoid;
  // } lama

  table {
    page-break-inside: auto;
  }

  tr {
    break-inside: avoid;
  }
  // tbody {
  //   display: block;
  // }
}
</style>

<script>
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import _ from "lodash";
import { DateTime } from "luxon";
import * as commonFunction from "@/utils/common-function.js";
// import { useCommonStore } from "@/stores/utility/common-store2";
// import * as commonFunction from "@/utils/common-function.js";

export default {
  // Component logic goes here
  setup() {
    // const commonStore = useCommonStore();
    // const gajiListStore = useGajiListStore();
    return {
      // commonStore,
      // gajiListStore,
      commonFunction,
    };
  },
  data() {
    return {
      tglAwal: this.$route.query.tglAwal,
      tglAkhir: this.$route.query.tglAkhir,
      statusGaji: this.$route.query.statusGaji,
      pejabatMengetahui: null,
      pejabatMembuat: null,
      pejabatMenyetujui: null,
      storePerbandingan: null,
      storeRekap: null,
      pejabat: null,
    };
  },
  // async created() {
  //   await this.commonStore.preloadStores();
  // },
  computed: {
    filteredKontrak() {
      return (index) => {
        return (
          this.storeRekap[index]?.kontrak.filter(
            (rekap) => rekap.value.honor_umk_jml !== null,
          ) || []
        );
      };
    },
  },
  async mounted() {
    this.pejabat = await this.commonFunction.getPejabatPengesahan(
      // DateTime.now().startOf("month").toISODate(),
      this.tglAkhir,
    );
    // await this.fetchDataPejabatPembuatGaji();
    await this.fetchDataPerbandingan();
    await this.fetchDataRekap();
  },

  methods: {
    convertTglIndonesia(inputDate) {
      if (!inputDate) return "";
      if (!this.isDateFormatYMD(inputDate)) return "";
      const parsedDate = DateTime.fromISO(inputDate);

      // Format the date in the desired Indonesian format
      const formattedDate = parsedDate.setLocale("id").toLocaleString({
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      return formattedDate;
    },
    isDateFormatYMD(dateString) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // Regular expression for Y-m-d format
      return dateRegex.test(dateString);
    },
    async fetchDataPejabatPembuatGaji() {
      try {
        const data = {
          tgl_gaji: this.tglAkhir,
        };

        const response = await axios.post(
          `${API_BASE_URL}/pejabat_gaji`,
          data,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          },
        );
        // this.gaji = response.data.gajis;
        this.pejabatMembuatTgl = this.convertTglIndonesia(
          response.data.tglGaji,
        );
        console.log("HASIL pejabatMembuatTgl", this.pejabatMembuatTgl);
        this.pejabatMengetahui = response.data.kabagUmum.simpeg_pegawai;
        this.pejabatMembuat = response.data.kasubagPersonalia.simpeg_pegawai;
        this.pejabatMenyetujui = response.data.dirum.simpeg_pegawai;

        // console.log("HASIL pejabatMengetahui", this.pejabatMengetahui);
        // console.log("HASIL SUMGAJIS", this.sumgajis);
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    formatNumberTerbilang(value) {
      if (typeof value === "string") {
        value = value.replace(/\./g, "");
      }

      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];
        // console.log(angkaTerbilang(stringValue));
        return _.startCase(angkaTerbilang(stringValue));
        // Add thousands separator
        // return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    formatNumber(value) {
      // if (value) {
      //   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      // }
      // return value;
      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];

        // Add thousands separator
        return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },
    toUpper(val) {
      return _.toUpper(val);
    },
    async fetchDataPerbandingan() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {
        tgl_gaji_awal: this.tglAwal,
        tgl_gaji_akhir: this.tglAkhir,
        status_gaji: this.statusGaji,
      };

      // const responsePerubahan = await axios.post(
      //   `${API_BASE_URL}/rekap_gaji_perubahan_data_pegawai`,
      //   data,
      //   config
      // );
      const responsePerubahan = await axios.post(
        `${API_BASE_URL}/rekap_gaji_perbandingan`,
        data,
        config,
      );
      this.storePerbandingan = responsePerubahan.data;
      console.log("storePerbandingan", this.storePerbandingan);
    },
    async fetchDataRekap() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {
        tgl_gaji_awal: this.tglAwal,
        tgl_gaji_akhir: this.tglAkhir,
        approved: this.statusGaji,
      };
      const response = await axios.post(
        `${API_BASE_URL}/rekap_gaji`,
        data,
        config,
      );

      this.storeRekap = response.data;

      console.log("storeRekap", this.storeRekap);
    },
  },
};
</script>
